import { z } from "zod";

export const isValidEmail = (value: string) =>
  z.string().email().safeParse(value).success;

// Internal email domains that
export const INTERNAL_EMAIL_DOMAINS = ["@grantedhealth.com", "@medbill.ai"];

export const isInternalEmail = (email?: string | null) =>
  email
    ? INTERNAL_EMAIL_DOMAINS.some(domain => email.endsWith(domain))
    : undefined;
